import { render, staticRenderFns } from "./WarehouseTransferUpdatePage.vue?vue&type=template&id=4c3e3a5e&"
import script from "./WarehouseTransferUpdatePage.vue?vue&type=script&lang=ts&"
export * from "./WarehouseTransferUpdatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c3e3a5e')) {
      api.createRecord('4c3e3a5e', component.options)
    } else {
      api.reload('4c3e3a5e', component.options)
    }
    module.hot.accept("./WarehouseTransferUpdatePage.vue?vue&type=template&id=4c3e3a5e&", function () {
      api.rerender('4c3e3a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/warehouse-transfer/WarehouseTransferUpdatePage.vue"
export default component.exports